import { Navigate } from 'react-router-dom';

const Index = () => <Navigate to="/calendar" replace />;

export default Index;
